<script setup>
import { computed } from "vue";
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const props = defineProps({
  labels: {
    type: Array,
    default: () => [],
  },
  totals: {
    type: Array,
    default: () => [],
  },
  personnel: {
    type: Array,
    default: () => [],
  },
  drivers: {
    type: Array,
    default: () => [],
  },
});

const chartData = computed(() => ({
  labels: props.labels,
  datasets: [
    {
      label: "Total",
      data: props.totals,
      backgroundColor: "rgba(14, 116, 144, 0.75)",
      borderColor: "rgba(14, 116, 144, 1)",
      borderWidth: 1,
      borderRadius: 5,
    },
    {
      label: "Personnel",
      data: props.personnel,
      backgroundColor: "rgba(16, 185, 129, 0.55)",
      borderColor: "rgba(16, 185, 129, 0.9)",
      borderWidth: 1,
      borderRadius: 5,
    },
    {
      label: "Driver",
      data: props.drivers,
      backgroundColor: "rgba(99, 102, 241, 0.55)",
      borderColor: "rgba(99, 102, 241, 0.9)",
      borderWidth: 1,
      borderRadius: 5,
    },
  ],
}));

const chartOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: "index",
    intersect: false,
  },
  scales: {
    x: {
      grid: { display: false },
      ticks: { color: "#64748b", maxRotation: 0, minRotation: 0 },
    },
    y: {
      beginAtZero: true,
      grid: { color: "rgba(148, 163, 184, 0.25)", drawBorder: false },
      ticks: {
        color: "#64748b",
        precision: 0,
      },
    },
  },
  plugins: {
    legend: { display: true },
    tooltip: {
      callbacks: {
        label: (context) => `${context.dataset.label}: ${context.parsed.y ?? 0} jobs`,
      },
    },
  },
}));
</script>

<template>
  <div class="w-full">
    <Bar :data="chartData" :options="chartOptions" class="h-64" />
  </div>
</template>
